import type { LoaderStatus, UiAction } from './actions';
import { SET_LOADER_STATUS } from './actions';

/**
 * Cross-cutting UI state that belongs to no one feature.
 *
 * Right now that is the save banner every mutation reports through. It used to
 * live in a separate Zustand store, which meant the app carried two state
 * libraries so that one non-React module could write one field.
 *
 * A plain switch reducer, matching the dashboard and emailAudit slices rather
 * than introducing a third style.
 */
export interface UiState {
  loaderStatus: LoaderStatus;
}

const initialState: UiState = {
  loaderStatus: { status: '', message: '' },
};

const uiReducer = (state = initialState, action: UiAction): UiState => {
  switch (action.type) {
    case SET_LOADER_STATUS:
      return { ...state, loaderStatus: action.payload };
    default:
      return state;
  }
};

export default uiReducer;
